import styles from './MatchScore.module.css';
import { motion } from 'motion/react';

export const MatchScore = ({ strMatchScore }) => {
  const regex = /^\s*(.*?)\s*(\d+\s*:\s*\d+)\s*(.*?)\s*$/;

  const match = strMatchScore.trim().match(regex);

  let team1 = '';
  let score = '';
  let team2 = '';

  if (match) {
    team1 = match[1];
    score = match[2];
    team2 = match[3];
  }

  return (
    <>
      {strMatchScore && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
          className={styles.matchScore}
        >
          <div className={styles.firstTeam}>{team1}</div>
          <motion.div
            key={score}
            className={styles.score}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
          >
            {score}
          </motion.div>
          <div className={styles.secondTeam}>{team2}</div>
        </motion.div>
      )}
    </>
  );
};
